module.exports = __webpack_public_path__ + "static/media/truck10.80662684.png";